<section class="c-section c-section--first u-no-pb" panel [isOpen]="true" *ngIf="vm.user?.origin == 'minudoc.ee'">
	<div class="c-section__header">
		<h1 class="c-section__title c-section__title--sm">{{ 'Wallet.Title.Balance' | translate }}</h1>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-40@md-and-up c-cell">
				<div class="c-card">
					<div class="c-content">
						<div class="o-grid" *ngIf="vm.balance?.businessWallet">
							<div class="o-grid__cell u-no-pl">
								<p class="c-text c-text--gray u-no-wrap">{{ 'Wallet.Other.Employer_Balance' | translate }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="!vm.balance?.businessWallet.sessionLimit">
								<p id="employerBalanceLabel" class="c-text c-text--right">{{ vm.balance?.businessWallet.balance || '0' }}{{ vm.balance?.businessWallet.currency | currency }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="vm.balance?.businessWallet.sessionLimit">
								<p id="employerBalanceLabel" class="c-text c-text--right">{{ vm.sessionsLeft || '0' }} {{ 'Services.Other.Sessions_Left' | translate }}</p>
							</div>
						</div>
						<div class="o-grid">
							<div class="o-grid__cell u-no-pl">
								<p class="c-text c-text--lg c-text--bold u-no-wrap">{{ 'Wallet.Other.Total_Balance' | translate }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
								<p id="privateBalanceLabel" class="c-text c-text--lg c-text--bold c-text--right c-text--main">{{ vm.balance?.balance || '0' }}{{ vm.balance?.currency | currency }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<div class="o-grid u-hidden@up-to-md">
	<div class="o-grid__cell" [ngClass]="{'u-ost-xl': vm.user?.origin == 'minudoc.ee'}">
		<list-tabs [tabs]="vm.tabs" [(activeTab)]="vm.type"></list-tabs>
	</div>
</div>
<section class="c-section u-no-pb" [ngClass]="{'u-hidden@md-and-up': vm.type!==0}" panel>
	<div class="c-section__header u-hidden@md-and-up">
		<h2 class="c-section__title">{{ 'Wallet.Title.Recent' | translate }}</h2>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-transactions></card-transactions>
			</div>
		</div>
	</div>
</section>
<section class="c-section c-section--last u-no-pb" [ngClass]="{'u-hidden@md-and-up': vm.type!==1}" panel>
	<div class="c-section__header u-hidden@md-and-up">
		<h2 class="c-section__title">{{ 'Invoices.Title' | translate }}</h2>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-invoices></card-invoices>
			</div>
		</div>
	</div>
</section>
